<template>
  <div class="calendar-options-data-dialog">
    <el-collapse v-model="activeNames" class="relative-setting-box">
      <el-collapse-item name="1" title="数据源">
        <div class="data-source-type mb12">
          <cx-slider :value.sync="isLocal" :options="dataOptions" :height="32" />
        </div>
        <div v-if="isLocal" class="dataSource-item" @click="goToChooseData">
          <span>进入数据管理后台 </span>
        </div>
        <data-center-choose
          v-show="!isLocal"
          :checkStatus="checkStatus"
          :myId="ids"
          :options="options"
          :jumpDirect="true"
          @onDataCenterChange="onDataCenterChange"
          @onAfterDataCenterChoose="onAfterDataCenterChoose"
          @onBeforeDataCenterUpdate="onBeforeDataCenterUpdate"
          @onAfterDataCenterUpdate="onAfterDataCenterUpdate"
        />
      </el-collapse-item>
      <el-collapse-item v-if="isLocal" name="2" title="文字内容">
        <div class="setting-item">
          <div class="content">
            <div class="content-item verticallyCenter">
              <div
                  class="edit-div"
                  contenteditable="true"
                  v-html="content"
                  @blur="blurFunc($event)"
                  @focus="focusFunc"
              ></div>
            </div>
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item name="3" title="更多">
        <auto-update-timer :isLocal="isLocal" :options="options" unit="分" />
        <div>
          <!-- <div class="getDataBtn mb16" @click="getBaseModuleDataLoop">查看数据响应结果</div> -->
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import autoUpdateTimer from "components/toolbar-option-components/utilsComponents/autoUpdateTimer/autoUpdateTimer.vue"
import dataCenterChoose from "publicSetting/dataCenterChoose.vue"
export default {
  name: "baidumap-options-data",
  components: { autoUpdateTimer, dataCenterChoose },
  props: { options: Object },
  data() {
    return {
      activeNames: ["1"],
      fetchEnd: false,
      appId: null,
      isLocal: true,
      localManual: true,
      source: 1
    }
  },
  mounted() {
    if(this.options.restDataUrl){
      this.getAllData()
    }
    this.$eventBus.$on("update-toolbar-data", this.updateToolbarData)
  },
  beforeDestroy() {
    window.removeEventListener("storage", this.listenData)
    this.$eventBus.$off("update-toolbar-data", this.updateToolbarData)
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    restDataUrl: {
      get() {
        return this.options && this.options.restDataUrl ? this.options.restDataUrl : null
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "restDataUrl", false)
      }
    },
    styleId() {
      return this.options.styleId
    },
    dataOptions() {
      const options = [{ value: true, title: "本地数据" }, { value: false, title: "数据中心" }]
      return options
    },
    checkStatus() {
      return this.getAttrById.call(this, this.$store.state[this.request_prefix], this.ids)
    },
    content: {
      get() {
        let content = `${this.options.content}`?.replace(/(<br>)*$/g, "") //替换末尾换行符
        return content
      },
      set(newVal) {
        newVal = String(newVal).replace(/<[^>]+>/g, "<br>")
        console.log("content===", newVal)
        this.$changeOptionsEV(newVal, "content", false)
      }
    },
  },
  watch: {
    isLocal: {
      handler(newVal) {
        // 手动切换到本地数据
        if(newVal && this.localManual && this.appId && this.source !== 1) {
          this.$confirm("确定使用本地资源？", "", {
            confirmButtonText: "确认",
            cancelButtonText: "取消",
            showClose: false,
            dangerouslyUseHTMLString: "<p>确定使用本地资源？</p>",
            iconClass: "bigScreen_confirm_icon el-icon-warning",
            cancelButtonClass: "bigScreen_confirm_cancel_button",
            confirmButtonClass: "bigScreen_confirm_button",
            customClass: "bigScreen_confirm custom_warning_dialog"
          }).then(() => {
            this.$API.setLocalData({ appId: this.appId, type: "general" }).then(() => {
              this.isLocal = true
              this.source = 1
              this.$changeOptionsEV("", "dataCenterName", false, null, this.myId, true)
              this.getBaseModuleDataLoop()
            })
          }).catch((e) => {
            this.isLocal = false
          })
        }
        this.localManual = true
      }
    }
  },
  methods: {
    onDataCenterChange() {
      this.getBaseModuleDataLoop()
    },
    onAfterDataCenterChoose() {
      window.addEventListener("storage", this.listenStorage)
    },
    listenStorage(e) {
      if (e.key == "page-v2-data-update") {
        // 后台配置或数据更新
        console.log("后台配置或数据更新 :>>")
        this.getBaseModuleDataLoop()
      }
    },
    updateToolbarData() {
      this.getBaseModuleDataLoop()
    },
    onBeforeDataCenterUpdate() {
      this.localManual = false
      this.isLocal = true
    },
    onAfterDataCenterUpdate(source) {
      this.localManual = false
      this.source = source
      this.isLocal = source === 1
    },
    goToChooseData() {
      if (this.fetchEnd) return
      this.fetchEnd = true
      const { websiteId, pageId } = this.$store.state.states.getDataPageIds
      const rectAttr = this.getRectAttribute(this.ids)
      let { moduleId, appId } = rectAttr
      if (moduleId === undefined) moduleId = rectAttr?.options?.moduleId
      if (appId === undefined) appId = rectAttr?.options?.appId
      if (!appId) {
        this.$saveModule(this.ids, "31CB73E03E24BBFF", "临时")
          .then(res => {
            this.fetchEnd = false
            if (res.appId) {
              // 模板问题，第一次需要手动将数据源切换为本地数据
              this.$API.setLocalData({ appId: res.appId, type: "general" }).then(() => {
                window.open(`/engine2/data/api-v2/admin/general/${res.appId}?w=${websiteId}&p=${pageId}&hideDataContent=true`)
              })
            }
          })
          .catch(err => (this.fetchEnd = false))
      }
      this.fetchEnd = false
      if (appId) window.open(`/engine2/data/api-v2/admin/general/${appId}?w=${websiteId}&p=${pageId}&hideDataContent=true`)
      // 数据自动渲染
      this.appId = appId
      window.addEventListener("storage", this.listenData)
    },
    getAllData() {
      if (!this.checkStatus) {
        this.$message({
          customClass: "bigScreen_msg_backGroud",
          duration: 3000,
          type: "error",
          message: "请进入数据管理后台添加数据"
        })
        return
      }
      this.updateNormalRect
        .call(this, datas => {
          if (datas.length > 0) {

            this.getBaseModuleDataLoop()
          }
        })
        .then(restDataUrl => {
          if (restDataUrl) {
            this.restDataUrl = restDataUrl.replace("engineInstanceId", "e").replace("typeId", "t")
          }
        })
    },
    async getBaseModuleDataLoop() {
      if (!this.checkStatus) {
        this.$message({
          customClass: "bigScreen_msg_backGroud",
          duration: 3000,
          type: "error",
          message: "请进入数据管理后台添加数据"
        })
        return
      }
      this.updateNormalRect
          .call(this, datas => {
            console.log("datas", datas)
          })
          .then(restDataUrl => {
            this.restDataUrl = restDataUrl
          })
    },
    //渲染数据
    renderDatas(datas) {

    },
    async getAppointData(filterValue) {
      return this.instance.get(this.restDataUrl + filterValue)
    },
    listenData(e) {
      const rectAttr = this.getRectAttribute(this.ids)
      let id = window.localStorage.getItem("page-v2-data-update-id")
      let appId = this.appId
      if (!appId) appId = rectAttr?.options?.appId
      if (e.key == "page-v2-general-data-type-add") {
        if (id == appId) {
          console.log("后台分类数据更新 :>>")
          this.getAllData()
        }
      }
      if (e.key == "page-v2-data-update") {
        // 后台配置或数据更新
        if (id == appId) {
          console.log("后台配置或数据更新 :>>")
          this.getAllData()
        }
      }
    },
    blurFunc($event) {
      this.content = $event.target.innerHTML
      sessionStorage.removeItem("isInputFocus")
    },
    focusFunc() {
      sessionStorage.setItem("isInputFocus", true)
    },
  }
}
</script>

<style lang="scss" scoped>
.dataContent {
  font-size: 14px;
  line-height: 22px;
  color: rgba(255, 255, 255, 0.8);
}
.getDataBtn {
  background: var(--themeColor);
  border-radius: 4px;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: #ffffff;
  padding: 6px 0px;
}
.getDataBtn:hover {
  cursor: pointer;
}
.dataSource-item {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 32px;
  background: var(--leftMenuBgColor);
  border: 1px solid var(--themeColor);
  border-radius: 4px;
  font-size: 14px;
  color: var(--themeColor);
  &:hover {
    cursor: pointer;
  }
}
.edit-div {
  width: 100%;
  background-color: var(--inputBackGround);
  border: var(--inputBorder);
  box-sizing: border-box;
  border-radius: 4px;
  padding: 4px;
}
.edit-div:focus {
  outline: none;
  border: 1px solid var(--themeColor);
}
</style>
